import { useState } from 'react'
import { ExpandMore, ChevronRight, CloudUpload } from '@material-ui/icons'

import { DocumentDownload } from '@base'
import { strings } from '@constants'
import { DocUploadButton } from '@pages/Profile/styles'

import {
	BasicDetailsCard,
	CardHeader,
	CardTitle,
	CardTitleRow,
	StatusLabel,
	HeaderRight,
	ChevronBtn,
	SectionDivider,
	DocTilesRow,
	DocTile,
	Note,
	EmptyState,
} from './style'

const DocumentCard = ({ config, documents, title, uploadLabel, onUpload, onDelete, editable = false, defaultOpen }) => {
	const { typeKey, field, isArray, titleKey, hideUploadWhenPresent, singleTile } = config
	const hasDocs = documents.length > 0
	const showUpload = editable && !(hideUploadWhenPresent && hasDocs)

	const [isOpen, setIsOpen] = useState(defaultOpen ?? hasDocs)

	const statusLabel = hasDocs ? `(${documents.length}-${documents.length > 1 ? strings('documents') : strings('document')})` : null

	// UploadButton hands back a single File (or a FileList when `multiple`); uploadDoc
	// expects an array, so normalize both shapes here.
	const handleUpload = (file) => onUpload(isArray ? Array.from(file) : [file])

	return (
		<BasicDetailsCard>
			<CardHeader $noBorder>
				<CardTitleRow>
					<CardTitle>{title ?? strings(titleKey)}</CardTitle>
					<StatusLabel $hasDocs={hasDocs}>{statusLabel}</StatusLabel>
				</CardTitleRow>
				<HeaderRight>
					{showUpload && (
						<DocUploadButton
							label={uploadLabel ?? strings('upload')}
							icon={<CloudUpload fontSize='small' />}
							multiple={isArray}
							onChange={handleUpload}
							xs
							uppercase
						/>
					)}
					<ChevronBtn onClick={() => setIsOpen((v) => !v)}>{isOpen ? <ExpandMore /> : <ChevronRight />}</ChevronBtn>
				</HeaderRight>
			</CardHeader>

			{isOpen && (
				<>
					<SectionDivider />
					{hasDocs ? (
						<>
							<DocTilesRow>
								{/* singleTile: one icon; the viewer pages through every file and hands
								    onDelete the path of the file being shown. */}
								{singleTile ? (
									<DocTile>
										<DocumentDownload
											link={documents}
											type={typeKey}
											onDelete={editable && onDelete ? (path) => onDelete(path, typeKey, field) : undefined}
										/>
									</DocTile>
								) : (
									documents.map((link, index) => (
										<DocTile key={`${typeKey}_${index}`}>
											<DocumentDownload
												link={link}
												type={typeKey}
												onDelete={editable && onDelete ? () => onDelete(link, typeKey, field) : undefined}
											/>
										</DocTile>
									))
								)}
							</DocTilesRow>
							<Note>{`${strings('note')}: ${strings('click_icon_to_download')}`}</Note>
						</>
					) : (
						<EmptyState>
							<span>{strings('no_document_has_been_uploaded')}</span>
							<span>{strings('click_upload_to_add_document')}</span>
						</EmptyState>
					)}
				</>
			)}
		</BasicDetailsCard>
	)
}

export default DocumentCard
